webpackJsonp([1],{

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeView_index__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeView_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HomeView_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ScheduleView_index__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ScheduleView_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ScheduleView_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HistoryView_index__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_HistoryView_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_HistoryView_index__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [{
    path: "/",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomeView_index___default.a
  }, {
    path: "/schedule",
    name: "Schedule",
    beforeEnter: function beforeEnter(to, from, next) {
      window.location = "https://horaro.org/trm/seven";
    }
  }, {
    path: "/history",
    name: "History",
    component: __WEBPACK_IMPORTED_MODULE_4__components_HistoryView_index___default.a
  }, {
    path: "*",
    redirect: "/"
  }]
}));

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_Navbar__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_global_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_global_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_FooterView__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_FooterView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_FooterView__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: { Navbar: __WEBPACK_IMPORTED_MODULE_0__components_global_Navbar___default.a, FooterView: __WEBPACK_IMPORTED_MODULE_1__components_global_FooterView___default.a },
  data: function data() {
    return {
      marathon: {
        mode: "post-marathon",
        name: "Tomb Raider Marathon VII",
        id: 7,
        charity: "Direct Relief",
        charity_url: "https://directrelief.org/",
        starts: "21st November 2020, 10am EST",
        starts_iso: "2020-11-21T15:00:00+00:00",
        starts_unix: new Date("2020-11-21T15:00:00+00:00").getTime() / 1000,
        latestVideo: "https://player.twitch.tv/?autoplay=false&collection=ANcPcRZ7ShY0QQ"
      },
      social: [{ link: "https://twitch.tv/tombraidermarathon", platform: "Twitch" }, { link: "http://discord.tombraidermarathon.com", platform: "Discord" }, { link: "https://twitter.com/tombraiderthon", platform: "Twitter" }, { link: "https://facebook.com/tombraiderthon", platform: "Facebook" }]
    };
  },

  methods: {
    setPageTitle: function setPageTitle(title) {
      document.getElementsByTagName("title")[0].innerText = "Tomb Raider Marathon - {$title}";
    }
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "history",
  data: function data() {
    return {
      history: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.http.get("/static/data/history.json").then(function (response) {
      if (response.status !== 200) return;

      var data = response.data;
      _this.history = data.history;
    });
  },


  filters: {
    localDate: function localDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).local().format("Do MMM YYYY, hh:mma");
    },
    durationToHours: function durationToHours(minutes) {
      return minutes / 60 + " hours";
    }
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_Timer__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_Timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_global_Timer__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Timer: __WEBPACK_IMPORTED_MODULE_1__components_global_Timer___default.a },
  name: "home",
  filters: {
    localDateTime: function localDateTime(dateString) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(dateString).local();
    }
  },

  computed: {
    hasMarathonStarted: function hasMarathonStarted() {
      var currentTime = Date.now() / 1000;
      return currentTime > this.$root.marathon.starts_unix;
    },
    twitchEmbedParent: function twitchEmbedParent() {
      return location.hostname;
    }
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "schedule",
  data: function data() {
    return {
      schedule: [],
      startUnixTimestamp: 0
    };
  },
  mounted: function mounted() {
    this.http.get("http://horaro.org/-/api/v1/events/trm/schedules/iv").then(function (response) {
      if (response.status !== 200) return;

      var data = response.data;
      console.log(data);
    });
  },


  filters: {
    localDate: function localDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).local().format("ddd Do MMM Y, hh:mma");
    },
    durationToHours: function durationToHours(minutes) {
      return minutes / 60 + " hrs";
    }
  },

  methods: {}
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'footerview',
	computed: {
		getCopyrightDate: function getCopyrightDate() {
			var date = new Date();
			var year = date.getFullYear();
			if (year > 2017) return ' - ' + year;

			return '';
		}
	}
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "navbar",
  data: function data() {
    return {
      hamburgerOpen: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    document.addEventListener("click", function (e) {
      if (e.target.className.indexOf("hamburger") > -1 || e.target.className.indexOf("fa-bars") > -1) {
        return;
      }

      _this.hamburgerOpen = false;
    });
  },


  computed: {
    navItems: function navItems() {
      var items = [];
      items.push({ link: "/", title: "Tomb Raider Marathon" },
      // {
      //   link: "https://horaro.org/trm/seven",
      //   title: "Schedule",
      //   isExternal: true
      // },
      { link: "/history", title: "History" });

      if (this.$root.marathon.mode == "marathon" || this.$root.marathon.mode == "donate") items.push({
        link: "//donate.tombraidermarathon.com",
        title: "Donate",
        isExternal: true
      });

      return items;
    }
  },

  methods: {
    toggleHamburger: function toggleHamburger() {
      this.hamburgerOpen = !this.hamburgerOpen;
    }
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'timer',
	data: function data() {
		return {
			interval: null,
			timeUntil: {}
		};
	},


	props: {
		target: Number
	},

	mounted: function mounted() {
		this.tick();
		this.interval = setInterval(this.tick, 1 * 1000);
	},


	methods: {
		tick: function tick() {
			this.calculateTimeRemaining();
		},
		calculateTimeRemaining: function calculateTimeRemaining() {
			this.timeUntil = {};

			if (this.$root.marathon.starts_unix === 0) return;

			var currentUnixTimestamp = new Date().getTime() / 1000;
			var targetUnixTimestamp = this.target | this.$root.marathon.starts_unix;

			var timeRemaining = Math.floor(Math.abs(currentUnixTimestamp - targetUnixTimestamp));
			if (timeRemaining === 0) return;

			var snowman = {
				day: 86400,
				hour: 3600,
				minute: 60,
				second: 1
			};

			var self = this;
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(snowman).forEach(function (key) {
				self.timeUntil[key] = Math.floor(timeRemaining / snowman[key]);
				timeRemaining -= self.timeUntil[key] * snowman[key];
			});
		}
	},

	filters: {
		pad: function pad(val) {
			if (val < 10) return "0" + val;

			return val;
		}
	}
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(155);








__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties___default()(__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].prototype, {
  http: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
    }
  },
  $http: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].filter('bool', function (v) {
  return v ? 'Yes' : 'No';
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_4__App___default.a)).$mount('#app');

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 26,
	"./af.js": 26,
	"./ar": 33,
	"./ar-dz": 27,
	"./ar-dz.js": 27,
	"./ar-kw": 28,
	"./ar-kw.js": 28,
	"./ar-ly": 29,
	"./ar-ly.js": 29,
	"./ar-ma": 30,
	"./ar-ma.js": 30,
	"./ar-sa": 31,
	"./ar-sa.js": 31,
	"./ar-tn": 32,
	"./ar-tn.js": 32,
	"./ar.js": 33,
	"./az": 34,
	"./az.js": 34,
	"./be": 35,
	"./be.js": 35,
	"./bg": 36,
	"./bg.js": 36,
	"./bm": 37,
	"./bm.js": 37,
	"./bn": 38,
	"./bn.js": 38,
	"./bo": 39,
	"./bo.js": 39,
	"./br": 40,
	"./br.js": 40,
	"./bs": 41,
	"./bs.js": 41,
	"./ca": 42,
	"./ca.js": 42,
	"./cs": 43,
	"./cs.js": 43,
	"./cv": 44,
	"./cv.js": 44,
	"./cy": 45,
	"./cy.js": 45,
	"./da": 46,
	"./da.js": 46,
	"./de": 49,
	"./de-at": 47,
	"./de-at.js": 47,
	"./de-ch": 48,
	"./de-ch.js": 48,
	"./de.js": 49,
	"./dv": 50,
	"./dv.js": 50,
	"./el": 51,
	"./el.js": 51,
	"./en-SG": 52,
	"./en-SG.js": 52,
	"./en-au": 53,
	"./en-au.js": 53,
	"./en-ca": 54,
	"./en-ca.js": 54,
	"./en-gb": 55,
	"./en-gb.js": 55,
	"./en-ie": 56,
	"./en-ie.js": 56,
	"./en-il": 57,
	"./en-il.js": 57,
	"./en-nz": 58,
	"./en-nz.js": 58,
	"./eo": 59,
	"./eo.js": 59,
	"./es": 62,
	"./es-do": 60,
	"./es-do.js": 60,
	"./es-us": 61,
	"./es-us.js": 61,
	"./es.js": 62,
	"./et": 63,
	"./et.js": 63,
	"./eu": 64,
	"./eu.js": 64,
	"./fa": 65,
	"./fa.js": 65,
	"./fi": 66,
	"./fi.js": 66,
	"./fo": 67,
	"./fo.js": 67,
	"./fr": 70,
	"./fr-ca": 68,
	"./fr-ca.js": 68,
	"./fr-ch": 69,
	"./fr-ch.js": 69,
	"./fr.js": 70,
	"./fy": 71,
	"./fy.js": 71,
	"./ga": 72,
	"./ga.js": 72,
	"./gd": 73,
	"./gd.js": 73,
	"./gl": 74,
	"./gl.js": 74,
	"./gom-latn": 75,
	"./gom-latn.js": 75,
	"./gu": 76,
	"./gu.js": 76,
	"./he": 77,
	"./he.js": 77,
	"./hi": 78,
	"./hi.js": 78,
	"./hr": 79,
	"./hr.js": 79,
	"./hu": 80,
	"./hu.js": 80,
	"./hy-am": 81,
	"./hy-am.js": 81,
	"./id": 82,
	"./id.js": 82,
	"./is": 83,
	"./is.js": 83,
	"./it": 85,
	"./it-ch": 84,
	"./it-ch.js": 84,
	"./it.js": 85,
	"./ja": 86,
	"./ja.js": 86,
	"./jv": 87,
	"./jv.js": 87,
	"./ka": 88,
	"./ka.js": 88,
	"./kk": 89,
	"./kk.js": 89,
	"./km": 90,
	"./km.js": 90,
	"./kn": 91,
	"./kn.js": 91,
	"./ko": 92,
	"./ko.js": 92,
	"./ku": 93,
	"./ku.js": 93,
	"./ky": 94,
	"./ky.js": 94,
	"./lb": 95,
	"./lb.js": 95,
	"./lo": 96,
	"./lo.js": 96,
	"./lt": 97,
	"./lt.js": 97,
	"./lv": 98,
	"./lv.js": 98,
	"./me": 99,
	"./me.js": 99,
	"./mi": 100,
	"./mi.js": 100,
	"./mk": 101,
	"./mk.js": 101,
	"./ml": 102,
	"./ml.js": 102,
	"./mn": 103,
	"./mn.js": 103,
	"./mr": 104,
	"./mr.js": 104,
	"./ms": 106,
	"./ms-my": 105,
	"./ms-my.js": 105,
	"./ms.js": 106,
	"./mt": 107,
	"./mt.js": 107,
	"./my": 108,
	"./my.js": 108,
	"./nb": 109,
	"./nb.js": 109,
	"./ne": 110,
	"./ne.js": 110,
	"./nl": 112,
	"./nl-be": 111,
	"./nl-be.js": 111,
	"./nl.js": 112,
	"./nn": 113,
	"./nn.js": 113,
	"./pa-in": 114,
	"./pa-in.js": 114,
	"./pl": 115,
	"./pl.js": 115,
	"./pt": 117,
	"./pt-br": 116,
	"./pt-br.js": 116,
	"./pt.js": 117,
	"./ro": 118,
	"./ro.js": 118,
	"./ru": 119,
	"./ru.js": 119,
	"./sd": 120,
	"./sd.js": 120,
	"./se": 121,
	"./se.js": 121,
	"./si": 122,
	"./si.js": 122,
	"./sk": 123,
	"./sk.js": 123,
	"./sl": 124,
	"./sl.js": 124,
	"./sq": 125,
	"./sq.js": 125,
	"./sr": 127,
	"./sr-cyrl": 126,
	"./sr-cyrl.js": 126,
	"./sr.js": 127,
	"./ss": 128,
	"./ss.js": 128,
	"./sv": 129,
	"./sv.js": 129,
	"./sw": 130,
	"./sw.js": 130,
	"./ta": 131,
	"./ta.js": 131,
	"./te": 132,
	"./te.js": 132,
	"./tet": 133,
	"./tet.js": 133,
	"./tg": 134,
	"./tg.js": 134,
	"./th": 135,
	"./th.js": 135,
	"./tl-ph": 136,
	"./tl-ph.js": 136,
	"./tlh": 137,
	"./tlh.js": 137,
	"./tr": 138,
	"./tr.js": 138,
	"./tzl": 139,
	"./tzl.js": 139,
	"./tzm": 141,
	"./tzm-latn": 140,
	"./tzm-latn.js": 140,
	"./tzm.js": 141,
	"./ug-cn": 142,
	"./ug-cn.js": 142,
	"./uk": 143,
	"./uk.js": 143,
	"./ur": 144,
	"./ur.js": 144,
	"./uz": 146,
	"./uz-latn": 145,
	"./uz-latn.js": 145,
	"./uz.js": 146,
	"./vi": 147,
	"./vi.js": 147,
	"./x-pseudo": 148,
	"./x-pseudo.js": 148,
	"./yo": 149,
	"./yo.js": 149,
	"./zh-cn": 150,
	"./zh-cn.js": 150,
	"./zh-hk": 151,
	"./zh-hk.js": 151,
	"./zh-tw": 152,
	"./zh-tw.js": 152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08b0cf59",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(233),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(219)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b8aa671c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bc7dc86e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d08d179",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f4ae66c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 231:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "history"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "history-table"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.history), function(marathon, index) {
    return _c('tr', {
      key: ("marathon." + index)
    }, [_c('td', [_vm._v(_vm._s(marathon.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(marathon.charity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("localDate")(marathon.start_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("localDate")(marathon.end_date)))]), _vm._v(" "), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("durationToHours")(marathon.duration)))]), _vm._v(" "), _c('td', {
      staticClass: "right"
    }, [_vm._v(_vm._s(marathon.attendees))]), _vm._v(" "), _c('td', {
      staticClass: "right"
    }, [_vm._v("$" + _vm._s(marathon.donation_total.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": marathon.playlist,
        "target": "_blank"
      }
    }, [_vm._v("Watch")])])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-spaced"
  }, [_vm._v("History")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Missed a marathon or want to see what we've done in the past? Check out past marathons below")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Marathon")]), _vm._v(" "), _c('th', [_vm._v("Charity")]), _vm._v(" "), _c('th', [_vm._v("Start Date")]), _vm._v(" "), _c('th', [_vm._v("End Date")]), _vm._v(" "), _c('th', {
    staticClass: "right"
  }, [_vm._v("Duration")]), _vm._v(" "), _c('th', {
    staticClass: "right"
  }, [_vm._v("Attendees")]), _vm._v(" "), _c('th', {
    staticClass: "right"
  }, [_vm._v("Donation Total")]), _vm._v(" "), _c('th', [_vm._v("Playlist")])])])
}]}

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trm-timer"
  }, [(_vm.timeUntil.day >= 0) ? _c('div', {
    staticClass: "trm-timer-val day"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("pad")(_vm.timeUntil.day)))]), _vm._v(" "), _c('span', [_vm._v("day" + _vm._s(_vm.timeUntil.day > 1 ? "s" : ""))])]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.hour >= 0) ? _c('div', {
    staticClass: "trm-timer-val hour"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("pad")(_vm.timeUntil.hour)))]), _vm._v(" "), _c('span', [_vm._v("hour" + _vm._s(_vm.timeUntil.hour > 1 ? "s" : ""))])]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.minute >= 0) ? _c('div', {
    staticClass: "trm-timer-val minute"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("pad")(_vm.timeUntil.minute)))]), _vm._v(" "), _c('span', [_vm._v("min" + _vm._s(_vm.timeUntil.minute > 1 ? "s" : ""))])]) : _vm._e(), _vm._v(" "), (_vm.timeUntil.second >= 0) ? _c('div', {
    staticClass: "trm-timer-val second"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("pad")(_vm.timeUntil.second)))]), _vm._v(" "), _c('span', [_vm._v("sec" + _vm._s(_vm.timeUntil.second > 1 ? "s" : ""))])]) : _c('span', [_vm._v("00:00:00:00")])])
},staticRenderFns: []}

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [(!_vm.hasMarathonStarted) ? _c('div', {
    staticClass: "marathon-countdown"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$root.marathon.name) + " starts in...")]), _vm._v(" "), _c('Timer'), _vm._v(" "), _c('div', {
    staticClass: "start-date"
  }, [_vm._v(_vm._s(_vm.$root.marathon.starts))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.marathon.mode == "marathon") ? _c('div', {
    attrs: {
      "id": "marathon_stream"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "marathon-info"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "hero has-text-centered"
  }, [_c('div', {
    staticClass: "hero-container"
  }, [_c('h2', [_vm._v("What is Tomb Raider Marathon?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$root.marathon.mode !== "post-marathon") ? [_c('h3', [_vm._v(_vm._s(_vm.$root.marathon.name))]), _vm._v(" "), _c('p', [_vm._v("\n              Join us on\n              "), _c('b', [_vm._v(_vm._s(_vm.$root.marathon.starts))]), _vm._v(", for our seventh marathon, "), _c('b', [_vm._v(_vm._s(_vm.$root.marathon.name))]), _vm._v("! This time we'll be raising for\n              "), _c('a', {
    attrs: {
      "href": _vm.$root.marathon.charity_url,
      "target": "_blank"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.marathon.charity))])])])] : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "marathon-video"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "hero has-text-centered"
  }, [_c('div', {
    staticClass: "hero-container"
  }, [_c('h2', [_vm._v("Tomb Raider Marathon VII Collection")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": ((_vm.$root.marathon.latestVideo) + "&parent=" + _vm.twitchEmbedParent),
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.twitch.tv/?channel=tombraidermarathon",
      "frameborder": "0",
      "allowfullscreen": "true",
      "scrolling": "no",
      "height": "480",
      "width": "70%"
    }
  }), _vm._v(" "), _c('iframe', {
    attrs: {
      "frameborder": "0",
      "scrolling": "yes",
      "height": "480",
      "width": "29%",
      "id": "tombraidermarathon",
      "src": "https://www.twitch.tv/embed/tombraidermarathon/chat"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Tomb Raider Marathon is a live stream gaming event where we play\n            through many of the Tomb Raider games both casually and super\n            quickly to raise money for charity. We have raised\n            "), _c('b', [_vm._v("$12,675.41‬")]), _vm._v(" since April 2017.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "marathon-finished"
  }, [_vm._v("\n            Tomb Raider Marathon VII raised\n            "), _c('b', [_vm._v("$2,450.00")]), _vm._v(", which surpassed our goal of $1,500!\n          ")])
}]}

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": ("/static/images/logos/trm-" + (_vm.$root.marathon.id) + ".png"),
      "alt": "TRM Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "hamburger-menu",
    on: {
      "click": _vm.toggleHamburger
    }
  }, [_c('span', {
    staticClass: "fa fa-bars"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navigation-area",
    class: {
      hamburgerOpen: _vm.hamburgerOpen
    }
  }, [_c('div', {
    staticClass: "social-media"
  }, [_c('ul', {
    staticClass: "social-channels"
  }, _vm._l((_vm.$root.social), function(social, index) {
    return _c('li', {
      key: ("social.item." + index),
      class: social.platform.toLowerCase()
    }, [_c('a', {
      attrs: {
        "href": social.link,
        "target": "_blank",
        "title": social.platform
      }
    }, [_c('span', {
      class: ("fa fa-" + (social.platform.toLowerCase()))
    })])])
  }), 0)]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      key: ("nav.item." + index),
      staticClass: "trm-nav-item",
      class: item.title.toLowerCase().replace(/ /g, "")
    }, [(item.isExternal !== true) ? _c('router-link', {
      attrs: {
        "to": {
          path: item.link
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])])])
},staticRenderFns: []}

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Navbar'), _vm._v(" "), _c('router-view', {
    staticClass: "router-view"
  }), _vm._v(" "), _c('FooterView')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "schedule-table"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.schedule), function(game, index) {
    return _c('tr', {
      key: ("game-" + index)
    }, [_c('td', [_c('span', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("localDate")(game.date)))])]), _vm._v(" "), _c('td', {
      staticClass: "duration cell-number"
    }, [_c('span', {
      staticClass: "fa fa-clock-o"
    }), _vm._v("\n              " + _vm._s(_vm._f("durationToHours")(game.duration)) + "\n            ")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "fa fa-gamepad"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(game.name))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(game.year))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(game.platform))])]), _vm._v(" "), _c('td', [(game.notes) ? [_c('span', {
      staticClass: "fa fa-comment"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(game.notes))])] : _vm._e()], 2), _vm._v(" "), (game.donation_total && game.donation_total.length > 0) ? [_c('td', {
      staticClass: "donation_total"
    }, [_c('span', {
      staticClass: "fa fa-arrow-up"
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(("$" + (game.donation_total.join('<br/><br/> $'))))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "donation_unlock"
    }, [_c('span', {
      staticClass: "fa fa-comments"
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(game.donation_unlock.join('<br/><br/>'))
      }
    })])] : _c('td', {
      staticClass: "no-padding",
      attrs: {
        "colspan": "2"
      }
    })], 2)
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-spaced"
  }, [_vm._v("Schedule")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("The schedule below is auto adjusted to your timezone")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('abbr', {
    attrs: {
      "title": "Estimated"
    }
  }, [_vm._v("Est.")]), _vm._v(" Date\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "duration"
  }, [_c('abbr', {
    attrs: {
      "title": "Estimated"
    }
  }, [_vm._v("Est.")]), _vm._v(" Duration\n            ")]), _vm._v(" "), _c('th', [_vm._v("Game")]), _vm._v(" "), _c('th', [_vm._v("Year")]), _vm._v(" "), _c('th', [_vm._v("Platform")])])])
}]}

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_vm._v("Copyright © Tomb Raider Marathon 2017 " + _vm._s(_vm.getCopyrightDate))]), _vm._v(" "), _c('p', [_vm._v("We are in no way associated with Square Enix or Crystal Dynamics, we're a non-profit fan-based charity gaming marathon that aims to have fun whilst raising money for charity.")])])])])
},staticRenderFns: []}

/***/ })

},[183]);


// WEBPACK FOOTER //
// static/js/app.7449f74d57da4a241465.js